import { ENTITY_TYPE } from '@/services/assignment/constants';
import graphqlRequest from '../skillsMasteryRequest';
import { AssignmentStatus, AssignmentType } from '@/enums';

const GET_STUDENT_SKILLS_MASTERY = `query getStudentSkillsMastery($studentId: [ID]!, $skillId: [ID], $dateFrom: AWSDate, $dateTo: AWSDate) {
  studentSkillsMastery(studentId: $studentId, skillId: $skillId, dateTo: $dateTo, dateFrom: $dateFrom) {
    studentId
    records {
      pacing
      skillId
    }
  }
}`;

export async function getStudentSkillsMastery({
  studentId,
  skillId,
  dateTo,
  dateFrom,
}) {
  let inputs = {
    studentId,
    skillId,
    dateTo,
    dateFrom,
  };

  return await graphqlRequest(GET_STUDENT_SKILLS_MASTERY, inputs);
}
